var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}pre_approved`,"viewBox":"0 0 16 16"}},[_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":"#0263CC"}}),_c('path',{staticClass:"sign",attrs:{"fill":"#fff","d":"M12 8a4 4 0 11-4-4v4h4z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }